<div *ngIf="!loader" class="col-12 col-md-12 col-lg-12 col-xl-12 pl-0 position-fixed vh-100">
    <div id="main2" class="vh-100 no-padding" [ngClass]="{'col-11':!sidebarState,'col-sm-11':!sidebarState,'col-md-9':!sidebarState,'col-lg-10':!sidebarState,'col-xl-10':!sidebarState,
    'col-12':sidebarState,'col-sm-12':sidebarState,'col-md-12':sidebarState,'col-lg-12':sidebarState,'col-xl-12':sidebarState
    }">
        <ng-scrollbar [trackX]="'true'"
                      #scrollable
                      track="all"
                      pointerEventsMethod="scrollbar">
            <div class="row ml-4 full-width"
                 [ngClass]="{'mt-4': !sidebarState,'ml-1': sidebarState}">

                <div class="full-width">
                    <div class="d-inline p-2">
                        <button class="btn btn-primary btn-sm boards-button-new cursor"
                                type="button"
                                (click)="addBoard()">
                            Dodaj board
                        </button>
                    </div>
                </div>


                <div class="row mr-5"
                     *ngFor="let board of boards; index as i">
                    <app-board-card
                            [boardData]="board">

                    </app-board-card>
                </div>
            </div>

        </ng-scrollbar>
    </div>
</div>
